module.exports = __webpack_public_path__ + "img/img76.59e0385b.svg";